export default __webpack_public_path__ + "static/media/M1A_9.dc16c660.png";